var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("EmdAddressBrazilianForm", {
        attrs: {
          searchZipCodeIsAllowed: _vm.canSearchZipCode,
          value: _vm.recipient.address,
          showSideBlock: _vm.showSideBlock,
        },
      }),
      _c("AddressReferencePointInput", {
        attrs: { recipient: _vm.recipient.address },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }